import { lazy } from 'react';

const AccessDenied = lazy(() => import('./AccessDenied'));

export default AccessDenied;
